import { render, staticRenderFns } from "./q-form.vue?vue&type=template&id=4c7efc34"
import script from "./q-form.vue?vue&type=script&lang=js"
export * from "./q-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports